// extracted by mini-css-extract-plugin
export default {"Backdrop":"Backdrop_Backdrop__iVu8d","hidden":"Backdrop_hidden__hMDrj","transparent":"Backdrop_transparent__MdQBx"};